export default {
  '@cloudscape-design/components': {
    en: {
      '[charts]': {
        loadingText: [{ type: 0, value: 'Loading chart' }],
        errorText: [{ type: 0, value: "The data couldn't be fetched. Try again later." }],
        recoveryText: [{ type: 0, value: 'Retry' }],
        'i18nStrings.filterLabel': [{ type: 0, value: 'Filter displayed data' }],
        'i18nStrings.filterPlaceholder': [{ type: 0, value: 'Filter data' }],
        'i18nStrings.legendAriaLabel': [{ type: 0, value: 'Legend' }],
        'i18nStrings.chartAriaRoleDescription': [{ type: 0, value: 'Chart' }],
        'i18nStrings.xAxisAriaRoleDescription': [{ type: 0, value: 'x-axis' }],
        'i18nStrings.yAxisAriaRoleDescription': [{ type: 0, value: 'y-axis' }],
      },
      alert: { dismissAriaLabel: [{ type: 0, value: 'Dismiss alert' }] },
      'annotation-context': {
        'i18nStrings.nextButtonText': [{ type: 0, value: 'Next' }],
        'i18nStrings.previousButtonText': [{ type: 0, value: 'Previous' }],
        'i18nStrings.finishButtonText': [{ type: 0, value: 'Finish' }],
        'i18nStrings.labelDismissAnnotation': [{ type: 0, value: 'Dismiss annotation' }],
        'i18nStrings.stepCounterText': [
          { type: 0, value: 'Step ' },
          { type: 1, value: 'stepNumber' },
          { type: 0, value: ' of ' },
          { type: 1, value: 'totalStepCount' },
        ],
        'i18nStrings.taskTitle': [
          { type: 0, value: 'Task ' },
          { type: 1, value: 'taskNumber' },
          { type: 0, value: ': ' },
          { type: 1, value: 'taskTitle' },
        ],
        'i18nStrings.labelHotspot': [
          {
            type: 5,
            value: 'openState',
            options: {
              true: {
                value: [
                  { type: 0, value: 'Close annotation for step ' },
                  { type: 1, value: 'stepNumber' },
                  { type: 0, value: ' of ' },
                  { type: 1, value: 'totalStepCount' },
                ],
              },
              false: {
                value: [
                  { type: 0, value: 'Open annotation for step ' },
                  { type: 1, value: 'stepNumber' },
                  { type: 0, value: ' of ' },
                  { type: 1, value: 'totalStepCount' },
                ],
              },
              other: { value: [] },
            },
          },
        ],
      },
      'app-layout': {
        'ariaLabels.drawers': [{ type: 0, value: 'Drawers' }],
        'ariaLabels.drawersOverflow': [{ type: 0, value: 'Drawers overflow' }],
        'ariaLabels.drawersOverflowWithBadge': [{ type: 0, value: 'Drawers overflow with badge' }],
        'ariaLabels.navigation': [{ type: 0, value: 'Side navigation' }],
        'ariaLabels.navigationClose': [{ type: 0, value: 'Close side navigation' }],
        'ariaLabels.navigationToggle': [{ type: 0, value: 'Open side navigation' }],
        'ariaLabels.notifications': [{ type: 0, value: 'Notifications' }],
        'ariaLabels.tools': [{ type: 0, value: 'Help panel' }],
        'ariaLabels.toolsClose': [{ type: 0, value: 'Close help panel' }],
        'ariaLabels.toolsToggle': [{ type: 0, value: 'Open help panel' }],
      },
      'area-chart': { 'i18nStrings.detailTotalLabel': [{ type: 0, value: 'Total' }] },
      'attribute-editor': { removeButtonText: [{ type: 0, value: 'Remove' }] },
      autosuggest: {
        errorIconAriaLabel: [{ type: 0, value: 'Error' }],
        selectedAriaLabel: [{ type: 0, value: 'Selected' }],
        enteredTextLabel: [
          { type: 0, value: 'Use: "' },
          { type: 1, value: 'value' },
          { type: 0, value: '"' },
        ],
        recoveryText: [{ type: 0, value: 'Retry' }],
      },
      'breadcrumb-group': { expandAriaLabel: [{ type: 0, value: 'Show path' }] },
      calendar: {
        nextMonthAriaLabel: [{ type: 0, value: 'Next month' }],
        previousMonthAriaLabel: [{ type: 0, value: 'Previous month' }],
        todayAriaLabel: [{ type: 0, value: 'Today' }],
      },
      cards: { 'ariaLabels.selectionGroupLabel': [{ type: 0, value: 'Item selection' }] },
      'code-editor': {
        'i18nStrings.loadingState': [{ type: 0, value: 'Loading code editor' }],
        'i18nStrings.errorState': [{ type: 0, value: 'There was an error loading the code editor.' }],
        'i18nStrings.errorStateRecovery': [{ type: 0, value: 'Retry' }],
        'i18nStrings.editorGroupAriaLabel': [{ type: 0, value: 'Code editor' }],
        'i18nStrings.statusBarGroupAriaLabel': [{ type: 0, value: 'Status bar' }],
        'i18nStrings.cursorPosition': [
          { type: 0, value: 'Ln ' },
          { type: 1, value: 'row' },
          { type: 0, value: ', Col ' },
          { type: 1, value: 'column' },
        ],
        'i18nStrings.errorsTab': [{ type: 0, value: 'Errors' }],
        'i18nStrings.warningsTab': [{ type: 0, value: 'Warnings' }],
        'i18nStrings.preferencesButtonAriaLabel': [{ type: 0, value: 'Preferences' }],
        'i18nStrings.paneCloseButtonAriaLabel': [{ type: 0, value: 'Close' }],
        'i18nStrings.preferencesModalHeader': [{ type: 0, value: 'Preferences' }],
        'i18nStrings.preferencesModalCancel': [{ type: 0, value: 'Cancel' }],
        'i18nStrings.preferencesModalConfirm': [{ type: 0, value: 'Confirm' }],
        'i18nStrings.preferencesModalWrapLines': [{ type: 0, value: 'Wrap lines' }],
        'i18nStrings.preferencesModalTheme': [{ type: 0, value: 'Theme' }],
        'i18nStrings.preferencesModalLightThemes': [{ type: 0, value: 'Light themes' }],
        'i18nStrings.preferencesModalDarkThemes': [{ type: 0, value: 'Dark themes' }],
      },
      'collection-preferences': {
        title: [{ type: 0, value: 'Preferences' }],
        confirmLabel: [{ type: 0, value: 'Confirm' }],
        cancelLabel: [{ type: 0, value: 'Cancel' }],
        'pageSizePreference.title': [{ type: 0, value: 'Page size' }],
        'wrapLinesPreference.label': [{ type: 0, value: 'Wrap lines' }],
        'wrapLinesPreference.description': [{ type: 0, value: 'Select to see all the text and wrap the lines' }],
        'stripedRowsPreference.label': [{ type: 0, value: 'Striped rows' }],
        'stripedRowsPreference.description': [{ type: 0, value: 'Select to add alternating shaded rows' }],
        'contentDensityPreference.label': [{ type: 0, value: 'Compact mode' }],
        'contentDensityPreference.description': [
          { type: 0, value: 'Select to display content in a denser, more compact mode' },
        ],
        'contentDisplayPreference.title': [{ type: 0, value: 'Column preferences' }],
        'contentDisplayPreference.description': [{ type: 0, value: 'Customize the columns visibility and order.' }],
        'contentDisplayPreference.dragHandleAriaLabel': [{ type: 0, value: 'Drag handle' }],
        'contentDisplayPreference.dragHandleAriaDescription': [
          {
            type: 0,
            value:
              "Use Space or Enter to activate drag for an item, then use the arrow keys to move the item's position. To complete the position move, use Space or Enter, or to discard the move, use Escape.",
          },
        ],
        'contentDisplayPreference.liveAnnouncementDndStarted': [
          { type: 0, value: 'Picked up item at position ' },
          { type: 1, value: 'position' },
          { type: 0, value: ' of ' },
          { type: 1, value: 'total' },
        ],
        'contentDisplayPreference.liveAnnouncementDndDiscarded': [{ type: 0, value: 'Reordering canceled' }],
        'contentDisplayPreference.liveAnnouncementDndItemReordered': [
          {
            type: 5,
            value: 'isInitialPosition',
            options: {
              true: {
                value: [
                  { type: 0, value: 'Moving item back to position ' },
                  { type: 1, value: 'currentPosition' },
                  { type: 0, value: ' of ' },
                  { type: 1, value: 'total' },
                ],
              },
              false: {
                value: [
                  { type: 0, value: 'Moving item to position ' },
                  { type: 1, value: 'currentPosition' },
                  { type: 0, value: ' of ' },
                  { type: 1, value: 'total' },
                ],
              },
              other: { value: [] },
            },
          },
        ],
        'contentDisplayPreference.liveAnnouncementDndItemCommitted': [
          {
            type: 5,
            value: 'isInitialPosition',
            options: {
              true: {
                value: [
                  { type: 0, value: 'Item moved back to its original position ' },
                  { type: 1, value: 'initialPosition' },
                  { type: 0, value: ' of ' },
                  { type: 1, value: 'total' },
                ],
              },
              false: {
                value: [
                  { type: 0, value: 'Item moved from position ' },
                  { type: 1, value: 'initialPosition' },
                  { type: 0, value: ' to position ' },
                  { type: 1, value: 'finalPosition' },
                  { type: 0, value: ' of ' },
                  { type: 1, value: 'total' },
                ],
              },
              other: { value: [] },
            },
          },
        ],
      },
      'date-range-picker': {
        'i18nStrings.relativeModeTitle': [{ type: 0, value: 'Relative mode' }],
        'i18nStrings.absoluteModeTitle': [{ type: 0, value: 'Absolute mode' }],
        'i18nStrings.relativeRangeSelectionHeading': [{ type: 0, value: 'Choose a range' }],
        'i18nStrings.cancelButtonLabel': [{ type: 0, value: 'Cancel' }],
        'i18nStrings.clearButtonLabel': [{ type: 0, value: 'Clear and dismiss' }],
        'i18nStrings.applyButtonLabel': [{ type: 0, value: 'Apply' }],
        'i18nStrings.customRelativeRangeOptionLabel': [{ type: 0, value: 'Custom range' }],
        'i18nStrings.customRelativeRangeOptionDescription': [{ type: 0, value: 'Set a custom range in the past' }],
        'i18nStrings.customRelativeRangeUnitLabel': [{ type: 0, value: 'Unit of time' }],
        'i18nStrings.customRelativeRangeDurationLabel': [{ type: 0, value: 'Duration' }],
        'i18nStrings.customRelativeRangeDurationPlaceholder': [{ type: 0, value: 'Enter a duration' }],
        'i18nStrings.startDateLabel': [{ type: 0, value: 'Start date' }],
        'i18nStrings.startTimeLabel': [{ type: 0, value: 'Start time' }],
        'i18nStrings.endDateLabel': [{ type: 0, value: 'End date' }],
        'i18nStrings.endTimeLabel': [{ type: 0, value: 'End time' }],
        'i18nStrings.dateTimeConstraintText': [
          { type: 0, value: 'For date, use YYYY/MM/DD. For time, use 24 hr format.' },
        ],
        'i18nStrings.errorIconAriaLabel': [{ type: 0, value: 'Error' }],
        'i18nStrings.renderSelectedAbsoluteRangeAriaLive': [
          { type: 0, value: 'Range selected from ' },
          { type: 1, value: 'startDate' },
          { type: 0, value: ' to ' },
          { type: 1, value: 'endDate' },
        ],
        'i18nStrings.formatRelativeRange': [
          {
            type: 6,
            value: 'amount',
            options: {
              one: {
                value: [
                  { type: 0, value: 'Last ' },
                  { type: 1, value: 'amount' },
                  { type: 0, value: ' ' },
                  { type: 1, value: 'unit' },
                ],
              },
              other: {
                value: [
                  { type: 0, value: 'Last ' },
                  { type: 1, value: 'amount' },
                  { type: 0, value: ' ' },
                  { type: 1, value: 'unit' },
                  { type: 0, value: 's' },
                ],
              },
            },
            offset: 0,
            pluralType: 'cardinal',
          },
        ],
        'i18nStrings.formatUnit': [
          {
            type: 6,
            value: 'amount',
            options: {
              one: { value: [{ type: 1, value: 'unit' }] },
              other: {
                value: [
                  { type: 1, value: 'unit' },
                  { type: 0, value: 's' },
                ],
              },
            },
            offset: 0,
            pluralType: 'cardinal',
          },
        ],
      },
      drawer: { 'i18nStrings.loadingText': [{ type: 0, value: 'Loading content' }] },
      flashbar: {
        'i18nStrings.ariaLabel': [{ type: 0, value: 'Notifications' }],
        'i18nStrings.errorIconAriaLabel': [{ type: 0, value: 'Error' }],
        'i18nStrings.inProgressIconAriaLabel': [{ type: 0, value: 'In progress' }],
        'i18nStrings.infoIconAriaLabel': [{ type: 0, value: 'Info' }],
        'i18nStrings.notificationBarAriaLabel': [{ type: 0, value: 'All notifications' }],
        'i18nStrings.notificationBarText': [{ type: 0, value: 'Notifications' }],
        'i18nStrings.successIconAriaLabel': [{ type: 0, value: 'Success' }],
        'i18nStrings.warningIconAriaLabel': [{ type: 0, value: 'Warning' }],
      },
      'form-field': { 'i18nStrings.errorIconAriaLabel': [{ type: 0, value: 'Error' }] },
      form: { errorIconAriaLabel: [{ type: 0, value: 'Error' }] },
      'help-panel': { loadingText: [{ type: 0, value: 'Loading content' }] },
      input: { clearAriaLabel: [{ type: 0, value: 'Clear' }] },
      link: { externalIconAriaLabel: [{ type: 0, value: 'Opens in a new tab' }] },
      modal: { closeAriaLabel: [{ type: 0, value: 'Close modal' }] },
      multiselect: {
        deselectAriaLabel: [
          { type: 0, value: 'Remove ' },
          { type: 1, value: 'option__label' },
        ],
      },
      pagination: {
        'ariaLabels.nextPageLabel': [{ type: 0, value: 'Next page' }],
        'ariaLabels.pageLabel': [
          { type: 0, value: 'Page ' },
          { type: 1, value: 'pageNumber' },
          { type: 0, value: ' of all pages' },
        ],
        'ariaLabels.previousPageLabel': [{ type: 0, value: 'Previous page' }],
      },
      'pie-chart': {
        'i18nStrings.detailsValue': [{ type: 0, value: 'Value' }],
        'i18nStrings.detailsPercentage': [{ type: 0, value: 'Percentage' }],
        'i18nStrings.chartAriaRoleDescription': [{ type: 0, value: 'Pie chart' }],
        'i18nStrings.segmentAriaRoleDescription': [{ type: 0, value: 'Segment' }],
      },
      popover: { dismissAriaLabel: [{ type: 0, value: 'Close popover' }] },
      'property-filter': {
        'i18nStrings.allPropertiesLabel': [{ type: 0, value: 'All properties' }],
        'i18nStrings.applyActionText': [{ type: 0, value: 'Apply' }],
        'i18nStrings.cancelActionText': [{ type: 0, value: 'Cancel' }],
        'i18nStrings.clearFiltersText': [{ type: 0, value: 'Clear filters' }],
        'i18nStrings.editTokenHeader': [{ type: 0, value: 'Edit filter' }],
        'i18nStrings.groupPropertiesText': [{ type: 0, value: 'Properties' }],
        'i18nStrings.groupValuesText': [{ type: 0, value: 'Values' }],
        'i18nStrings.operationAndText': [{ type: 0, value: 'and' }],
        'i18nStrings.operationOrText': [{ type: 0, value: 'or' }],
        'i18nStrings.operatorContainsText': [{ type: 0, value: 'Contains' }],
        'i18nStrings.operatorDoesNotContainText': [{ type: 0, value: 'Does not contain' }],
        'i18nStrings.operatorDoesNotEqualText': [{ type: 0, value: 'Does not equal' }],
        'i18nStrings.operatorEqualsText': [{ type: 0, value: 'Equals' }],
        'i18nStrings.operatorGreaterOrEqualText': [{ type: 0, value: 'Greater than or equal' }],
        'i18nStrings.operatorGreaterText': [{ type: 0, value: 'Greater than' }],
        'i18nStrings.operatorLessOrEqualText': [{ type: 0, value: 'Less than or equal' }],
        'i18nStrings.operatorLessText': [{ type: 0, value: 'Less than' }],
        'i18nStrings.operatorStartsWithText': [{ type: 0, value: 'Starts with' }],
        'i18nStrings.operatorText': [{ type: 0, value: 'Operator' }],
        'i18nStrings.operatorsText': [{ type: 0, value: 'Operators' }],
        'i18nStrings.propertyText': [{ type: 0, value: 'Property' }],
        'i18nStrings.tokenLimitShowFewer': [{ type: 0, value: 'Show fewer' }],
        'i18nStrings.tokenLimitShowMore': [{ type: 0, value: 'Show more' }],
        'i18nStrings.valueText': [{ type: 0, value: 'Value' }],
        'i18nStrings.removeTokenButtonAriaLabel': [
          {
            type: 5,
            value: 'token__operator',
            options: {
              equals: {
                value: [
                  { type: 0, value: 'Remove filter, ' },
                  { type: 1, value: 'token__propertyKey' },
                  { type: 0, value: ' equals ' },
                  { type: 1, value: 'token__value' },
                ],
              },
              not_equals: {
                value: [
                  { type: 0, value: 'Remove filter, ' },
                  { type: 1, value: 'token__propertyKey' },
                  { type: 0, value: ' does not equal ' },
                  { type: 1, value: 'token__value' },
                ],
              },
              greater_than: {
                value: [
                  { type: 0, value: 'Remove filter, ' },
                  { type: 1, value: 'token__propertyKey' },
                  { type: 0, value: ' is greater than ' },
                  { type: 1, value: 'token__value' },
                ],
              },
              greater_than_equal: {
                value: [
                  { type: 0, value: 'Remove filter, ' },
                  { type: 1, value: 'token__propertyKey' },
                  { type: 0, value: ' is greater than or equal to ' },
                  { type: 1, value: 'token__value' },
                ],
              },
              less_than: {
                value: [
                  { type: 0, value: 'Remove filter, ' },
                  { type: 1, value: 'token__propertyKey' },
                  { type: 0, value: ' is less than ' },
                  { type: 1, value: 'token__value' },
                ],
              },
              less_than_equal: {
                value: [
                  { type: 0, value: 'Remove filter, ' },
                  { type: 1, value: 'token__propertyKey' },
                  { type: 0, value: ' is less than or equal to ' },
                  { type: 1, value: 'token__value' },
                ],
              },
              contains: {
                value: [
                  { type: 0, value: 'Remove filter, ' },
                  { type: 1, value: 'token__propertyKey' },
                  { type: 0, value: ' contains ' },
                  { type: 1, value: 'token__value' },
                ],
              },
              not_contains: {
                value: [
                  { type: 0, value: 'Remove filter, ' },
                  { type: 1, value: 'token__propertyKey' },
                  { type: 0, value: ' does not contain ' },
                  { type: 1, value: 'token__value' },
                ],
              },
              starts_with: {
                value: [
                  { type: 0, value: 'Remove filter, ' },
                  { type: 1, value: 'token__propertyKey' },
                  { type: 0, value: ' starts with ' },
                  { type: 1, value: 'token__value' },
                ],
              },
              other: { value: [] },
            },
          },
        ],
      },
      's3-resource-selector': {
        'i18nStrings.inContextSelectPlaceholder': [{ type: 0, value: 'Choose a version' }],
        'i18nStrings.inContextBrowseButton': [{ type: 0, value: 'Browse S3' }],
        'i18nStrings.inContextViewButton': [{ type: 0, value: 'View' }],
        'i18nStrings.inContextViewButtonAriaLabel': [{ type: 0, value: 'View (opens in a new tab)' }],
        'i18nStrings.inContextLoadingText': [{ type: 0, value: 'Loading resource' }],
        'i18nStrings.inContextUriLabel': [{ type: 0, value: 'S3 URI' }],
        'i18nStrings.inContextVersionSelectLabel': [{ type: 0, value: 'Object version' }],
        'i18nStrings.modalTitle': [{ type: 0, value: 'Choose an archive in S3' }],
        'i18nStrings.modalCancelButton': [{ type: 0, value: 'Cancel' }],
        'i18nStrings.modalSubmitButton': [{ type: 0, value: 'Choose' }],
        'i18nStrings.modalBreadcrumbRootItem': [{ type: 0, value: 'S3 buckets' }],
        'i18nStrings.selectionBuckets': [{ type: 0, value: 'Buckets' }],
        'i18nStrings.selectionObjects': [{ type: 0, value: 'Objects' }],
        'i18nStrings.selectionVersions': [{ type: 0, value: 'Versions' }],
        'i18nStrings.selectionBucketsSearchPlaceholder': [{ type: 0, value: 'Find bucket' }],
        'i18nStrings.selectionObjectsSearchPlaceholder': [{ type: 0, value: 'Find object by prefix' }],
        'i18nStrings.selectionVersionsSearchPlaceholder': [{ type: 0, value: 'Find version' }],
        'i18nStrings.selectionBucketsLoading': [{ type: 0, value: 'Loading buckets' }],
        'i18nStrings.selectionBucketsNoItems': [{ type: 0, value: 'No buckets' }],
        'i18nStrings.selectionObjectsLoading': [{ type: 0, value: 'Loading objects' }],
        'i18nStrings.selectionObjectsNoItems': [{ type: 0, value: 'No objects' }],
        'i18nStrings.selectionVersionsLoading': [{ type: 0, value: 'Loading versions' }],
        'i18nStrings.selectionVersionsNoItems': [{ type: 0, value: 'No versions' }],
        'i18nStrings.filteringNoMatches': [{ type: 0, value: 'No matches' }],
        'i18nStrings.filteringCantFindMatch': [{ type: 0, value: "We can't find a match." }],
        'i18nStrings.clearFilterButtonText': [{ type: 0, value: 'Clear filter' }],
        'i18nStrings.columnBucketID': [{ type: 0, value: 'ID' }],
        'i18nStrings.columnBucketName': [{ type: 0, value: 'Name' }],
        'i18nStrings.columnBucketCreationDate': [{ type: 0, value: 'Creation date' }],
        'i18nStrings.columnBucketRegion': [{ type: 0, value: 'Region' }],
        'i18nStrings.columnObjectKey': [{ type: 0, value: 'Key' }],
        'i18nStrings.columnObjectLastModified': [{ type: 0, value: 'Last modified' }],
        'i18nStrings.columnObjectSize': [{ type: 0, value: 'Size' }],
        'i18nStrings.columnVersionID': [{ type: 0, value: 'Version ID' }],
        'i18nStrings.columnVersionLastModified': [{ type: 0, value: 'Last modified' }],
        'i18nStrings.columnVersionSize': [{ type: 0, value: 'Size' }],
        'i18nStrings.validationPathMustBegin': [{ type: 0, value: 'The path must begin with s3:// to be valid.' }],
        'i18nStrings.validationBucketLowerCase': [
          { type: 0, value: 'The bucket name must start with a lowercase character or number.' },
        ],
        'i18nStrings.validationBucketMustNotContain': [
          { type: 0, value: 'The bucket name must not contain uppercase characters.' },
        ],
        'i18nStrings.validationBucketLength': [{ type: 0, value: 'The bucket name must be from 3 to 63 characters.' }],
        'i18nStrings.validationBucketMustComplyDns': [
          { type: 0, value: 'The bucket name must comply with DNS naming conventions.' },
        ],
        'i18nStrings.labelSortedDescending': [
          { type: 1, value: 'columnName' },
          { type: 0, value: ', sorted descending' },
        ],
        'i18nStrings.labelSortedAscending': [
          { type: 1, value: 'columnName' },
          { type: 0, value: ', sorted ascending' },
        ],
        'i18nStrings.labelNotSorted': [
          { type: 1, value: 'columnName' },
          { type: 0, value: ', not sorted' },
        ],
        'i18nStrings.labelsBucketsSelection.selectionGroupLabel': [{ type: 0, value: 'Buckets' }],
        'i18nStrings.labelsBucketsSelection.itemSelectionLabel': [{ type: 1, value: 'item__Name' }],
        'i18nStrings.labelsObjectsSelection.selectionGroupLabel': [{ type: 0, value: 'Objects' }],
        'i18nStrings.labelsObjectsSelection.itemSelectionLabel': [{ type: 1, value: 'item__Key' }],
        'i18nStrings.labelsVersionsSelection.selectionGroupLabel': [{ type: 0, value: 'Versions' }],
        'i18nStrings.labelsVersionsSelection.itemSelectionLabel': [{ type: 1, value: 'item__VersionId' }],
        'i18nStrings.labelFiltering': [
          { type: 0, value: 'Find ' },
          { type: 1, value: 'itemsType' },
        ],
        'i18nStrings.labelRefresh': [{ type: 0, value: 'Refresh the data' }],
        'i18nStrings.labelBreadcrumbs': [{ type: 0, value: 'S3 navigation' }],
        'i18nStrings.filteringCounterText': [
          {
            type: 6,
            value: 'count',
            options: {
              one: { value: [{ type: 0, value: '1 match' }] },
              other: {
                value: [
                  { type: 1, value: 'count' },
                  { type: 0, value: ' matches' },
                ],
              },
            },
            offset: 0,
            pluralType: 'cardinal',
          },
        ],
      },
      select: {
        errorIconAriaLabel: [{ type: 0, value: 'Error' }],
        selectedAriaLabel: [{ type: 0, value: 'Selected' }],
        recoveryText: [{ type: 0, value: 'Retry' }],
      },
      'split-panel': {
        'i18nStrings.closeButtonAriaLabel': [{ type: 0, value: 'Close panel' }],
        'i18nStrings.openButtonAriaLabel': [{ type: 0, value: 'Open panel' }],
        'i18nStrings.preferencesTitle': [{ type: 0, value: 'Split panel preferences' }],
        'i18nStrings.preferencesPositionLabel': [{ type: 0, value: 'Split panel position' }],
        'i18nStrings.preferencesPositionDescription': [
          { type: 0, value: 'Choose the default split panel position for the service.' },
        ],
        'i18nStrings.preferencesPositionSide': [{ type: 0, value: 'Side' }],
        'i18nStrings.preferencesPositionBottom': [{ type: 0, value: 'Bottom' }],
        'i18nStrings.preferencesConfirm': [{ type: 0, value: 'Confirm' }],
        'i18nStrings.preferencesCancel': [{ type: 0, value: 'Cancel' }],
        'i18nStrings.resizeHandleAriaLabel': [{ type: 0, value: 'Resize split panel' }],
      },
      table: {
        'ariaLabels.resizerRoleDescription': [{ type: 0, value: 'resize button' }],
        'ariaLabels.submittingEditText': [{ type: 0, value: 'Submitting edit' }],
        'ariaLabels.successfulEditLabel': [{ type: 0, value: 'Edit successful' }],
        'columnDefinitions.editConfig.errorIconAriaLabel': [{ type: 0, value: 'Error' }],
        'columnDefinitions.editConfig.editIconAriaLabel': [{ type: 0, value: 'editable' }],
      },
      tabs: {
        'i18nStrings.scrollLeftAriaLabel': [{ type: 0, value: 'Scroll left' }],
        'i18nStrings.scrollRightAriaLabel': [{ type: 0, value: 'Scroll right' }],
      },
      'tag-editor': {
        'i18nStrings.keyPlaceholder': [{ type: 0, value: 'Enter key' }],
        'i18nStrings.valuePlaceholder': [{ type: 0, value: 'Enter value' }],
        'i18nStrings.addButton': [{ type: 0, value: 'Add new tag' }],
        'i18nStrings.removeButton': [{ type: 0, value: 'Remove' }],
        'i18nStrings.removeButtonAriaLabel': [
          { type: 0, value: 'Remove ' },
          { type: 1, value: 'tag__key' },
        ],
        'i18nStrings.undoButton': [{ type: 0, value: 'Undo' }],
        'i18nStrings.undoPrompt': [{ type: 0, value: 'This tag will be removed upon saving changes' }],
        'i18nStrings.loading': [{ type: 0, value: 'Loading tags that are associated with this resource' }],
        'i18nStrings.keyHeader': [{ type: 0, value: 'Key' }],
        'i18nStrings.valueHeader': [{ type: 0, value: 'Value' }],
        'i18nStrings.optional': [{ type: 0, value: 'optional' }],
        'i18nStrings.keySuggestion': [{ type: 0, value: 'Custom tag key' }],
        'i18nStrings.valueSuggestion': [{ type: 0, value: 'Custom tag value' }],
        'i18nStrings.emptyTags': [{ type: 0, value: 'No tags associated with the resource.' }],
        'i18nStrings.tooManyKeysSuggestion': [{ type: 0, value: 'You have more keys than can be displayed' }],
        'i18nStrings.tooManyValuesSuggestion': [{ type: 0, value: 'You have more values than can be displayed' }],
        'i18nStrings.keysSuggestionLoading': [{ type: 0, value: 'Loading tag keys' }],
        'i18nStrings.keysSuggestionError': [{ type: 0, value: 'Tag keys could not be retrieved' }],
        'i18nStrings.valuesSuggestionLoading': [{ type: 0, value: 'Loading tag values' }],
        'i18nStrings.valuesSuggestionError': [{ type: 0, value: 'Tag values could not be retrieved' }],
        'i18nStrings.emptyKeyError': [{ type: 0, value: 'You must specify a tag key' }],
        'i18nStrings.maxKeyCharLengthError': [
          { type: 0, value: 'The maximum number of characters you can use in a tag key is 128.' },
        ],
        'i18nStrings.maxValueCharLengthError': [
          { type: 0, value: 'The maximum number of characters you can use in a tag value is 256.' },
        ],
        'i18nStrings.duplicateKeyError': [{ type: 0, value: 'You must specify a unique tag key.' }],
        'i18nStrings.invalidKeyError': [
          {
            type: 0,
            value:
              'Invalid key. Keys can only contain Unicode letters, digits, white space and any of the following: _.:/=+@-',
          },
        ],
        'i18nStrings.invalidValueError': [
          {
            type: 0,
            value:
              'Invalid value. Values can only contain Unicode letters, digits, white space and any of the following: _.:/=+@-',
          },
        ],
        'i18nStrings.awsPrefixError': [{ type: 0, value: 'Cannot start with aws:' }],
        'i18nStrings.tagLimitReached': [
          {
            type: 6,
            value: 'tagLimit',
            options: {
              one: { value: [{ type: 0, value: 'You have reached the limit of 1 tag.' }] },
              other: {
                value: [
                  { type: 0, value: 'You have reached the limit of ' },
                  { type: 1, value: 'tagLimit' },
                  { type: 0, value: ' tags.' },
                ],
              },
            },
            offset: 0,
            pluralType: 'cardinal',
          },
        ],
        'i18nStrings.tagLimitExceeded': [
          {
            type: 6,
            value: 'tagLimit',
            options: {
              one: { value: [{ type: 0, value: 'You have exceeded the limit of 1 tag.' }] },
              other: {
                value: [
                  { type: 0, value: 'You have exceeded the limit of ' },
                  { type: 1, value: 'tagLimit' },
                  { type: 0, value: ' tags.' },
                ],
              },
            },
            offset: 0,
            pluralType: 'cardinal',
          },
        ],
        'i18nStrings.tagLimit': [
          {
            type: 5,
            value: 'tagLimitAvailable',
            options: {
              true: {
                value: [
                  {
                    type: 6,
                    value: 'availableTags',
                    options: {
                      other: {
                        value: [
                          { type: 0, value: 'You can add up to ' },
                          { type: 1, value: 'tagLimit' },
                          { type: 0, value: ' tags.' },
                        ],
                      },
                    },
                    offset: 0,
                    pluralType: 'cardinal',
                  },
                ],
              },
              false: {
                value: [
                  {
                    type: 6,
                    value: 'availableTags',
                    options: {
                      one: { value: [{ type: 0, value: 'You can add up to 1 more tag.' }] },
                      other: {
                        value: [
                          { type: 0, value: 'You can add up to ' },
                          { type: 1, value: 'availableTags' },
                          { type: 0, value: ' more tags.' },
                        ],
                      },
                    },
                    offset: 0,
                    pluralType: 'cardinal',
                  },
                ],
              },
              other: { value: [] },
            },
          },
        ],
      },
      'token-group': {
        'i18nStrings.limitShowFewer': [{ type: 0, value: 'Show fewer' }],
        'i18nStrings.limitShowMore': [{ type: 0, value: 'Show more' }],
      },
      'top-navigation': {
        'i18nStrings.searchIconAriaLabel': [{ type: 0, value: 'Search' }],
        'i18nStrings.searchDismissIconAriaLabel': [{ type: 0, value: 'Close search' }],
        'i18nStrings.overflowMenuTriggerText': [{ type: 0, value: 'More' }],
        'i18nStrings.overflowMenuDismissIconAriaLabel': [{ type: 0, value: 'Close menu' }],
        'i18nStrings.overflowMenuBackIconAriaLabel': [{ type: 0, value: 'Back' }],
        'i18nStrings.overflowMenuTitleText': [{ type: 0, value: 'All' }],
      },
      'tutorial-panel': {
        'i18nStrings.loadingText': [{ type: 0, value: 'Loading' }],
        'i18nStrings.tutorialListTitle': [{ type: 0, value: 'Choose a tutorial' }],
        'i18nStrings.tutorialListDownloadLinkText': [{ type: 0, value: 'Download PDF version' }],
        'i18nStrings.labelTutorialListDownloadLink': [{ type: 0, value: 'Download PDF version of this tutorial' }],
        'i18nStrings.tutorialCompletedText': [{ type: 0, value: 'Tutorial completed' }],
        'i18nStrings.learnMoreLinkText': [{ type: 0, value: 'Learn more' }],
        'i18nStrings.startTutorialButtonText': [{ type: 0, value: 'Start tutorial' }],
        'i18nStrings.restartTutorialButtonText': [{ type: 0, value: 'Restart tutorial' }],
        'i18nStrings.completionScreenTitle': [{ type: 0, value: 'Congratulations! You completed the tutorial.' }],
        'i18nStrings.feedbackLinkText': [{ type: 0, value: 'Feedback' }],
        'i18nStrings.dismissTutorialButtonText': [{ type: 0, value: 'Dismiss tutorial' }],
        'i18nStrings.taskTitle': [
          { type: 0, value: 'Task ' },
          { type: 1, value: 'taskNumber' },
          { type: 0, value: ': ' },
          { type: 1, value: 'taskTitle' },
        ],
        'i18nStrings.stepTitle': [
          { type: 0, value: 'Step ' },
          { type: 1, value: 'stepNumber' },
          { type: 0, value: ': ' },
          { type: 1, value: 'stepTitle' },
        ],
        'i18nStrings.labelExitTutorial': [{ type: 0, value: 'Dismiss tutorial' }],
        'i18nStrings.labelTotalSteps': [
          { type: 0, value: 'Total steps: ' },
          { type: 1, value: 'totalStepCount' },
        ],
        'i18nStrings.labelsTaskStatus.pending': [{ type: 0, value: 'Pending' }],
        'i18nStrings.labelsTaskStatus.in-progress': [{ type: 0, value: 'In progress' }],
        'i18nStrings.labelsTaskStatus.success': [{ type: 0, value: 'Success' }],
      },
      wizard: {
        'i18nStrings.stepNumberLabel': [
          { type: 0, value: 'Step ' },
          { type: 1, value: 'stepNumber' },
        ],
        'i18nStrings.collapsedStepsLabel': [
          { type: 0, value: 'Step ' },
          { type: 1, value: 'stepNumber' },
          { type: 0, value: ' of ' },
          { type: 1, value: 'stepsCount' },
        ],
        'i18nStrings.skipToButtonLabel': [
          { type: 0, value: 'Skip to ' },
          { type: 1, value: 'task__title' },
        ],
        'i18nStrings.navigationAriaLabel': [{ type: 0, value: 'Steps' }],
        'i18nStrings.cancelButton': [{ type: 0, value: 'Cancel' }],
        'i18nStrings.previousButton': [{ type: 0, value: 'Previous' }],
        'i18nStrings.nextButton': [{ type: 0, value: 'Next' }],
        'i18nStrings.optional': [{ type: 0, value: 'optional' }],
        'i18nStrings.nextButtonLoadingAnnouncement': [{ type: 0, value: 'Loading next step' }],
        'i18nStrings.submitButtonLoadingAnnouncement': [{ type: 0, value: 'Submitting form' }],
      },
    },
  },
};
